module.exports = __webpack_public_path__ + "img/5.07.c69206c0.jpg";